import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Loader from '../../../components/Common/Loader/Loader';
import ViewBookingDetails from '../../../components/ViewBookingDetails';
import SocketContext from '../../../core/socketNotifications/SocketContext';
import NotFound from '../../../components/NotFound/NotFound';

import viewBookingDetails from './viewBookingDetails.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import messages from '../../../locale/messages';

// Phase 2 banner: when a manual booking is frozen awaiting the client's confirm-via-link, let the admin
// re-send the link or cancel the pending booking. Calls the public /graphql from the admin session.
function AwaitingCardBanner({ booking, refetch }) {
	const [msg, setMsg] = React.useState(null);
	const [busy, setBusy] = React.useState(false);
	const call = (query, variables) => fetch('/graphql', {
		method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include',
		body: JSON.stringify({ query, variables }),
	}).then(r => r.json());
	const resend = async () => {
		setBusy(true); setMsg(null);
		const j = await call(`mutation($id:Int){ resendClientCardLink(bookingId:$id){ status errorMessage } }`, { id: Number(booking.id) });
		const r = j && j.data && j.data.resendClientCardLink;
		setMsg(r && r.status === 200 ? 'Link re-sent to the client ✅' : ((r && r.errorMessage) || 'Could not resend the link.'));
		setBusy(false);
	};
	const cancel = async () => {
		if (typeof window !== 'undefined' && !window.confirm('Cancel this pending booking?')) return;
		setBusy(true); setMsg(null);
		const j = await call(`mutation($id:Int){ cancelPendingBooking(bookingId:$id){ status errorMessage } }`, { id: Number(booking.id) });
		const r = j && j.data && j.data.cancelPendingBooking;
		if (r && r.status === 200) { setMsg('Booking cancelled.'); if (refetch) refetch(); }
		else setMsg((r && r.errorMessage) || 'Could not cancel.');
		setBusy(false);
	};
	const box = { background: '#FFF7E6', border: '1px solid #FFE0A3', borderRadius: 10, padding: '14px 16px', margin: '0 0 16px' };
	const btn = { background: '#16a34a', color: '#fff', border: 0, borderRadius: 8, padding: '9px 16px', fontWeight: 'bold', cursor: 'pointer', marginRight: 10 };
	const btnGhost = { ...btn, background: 'transparent', color: '#c0392b', border: '1px solid #c0392b' };
	return (
		<div style={box}>
			<div style={{ fontWeight: 'bold', marginBottom: 4 }}>⏳ Awaiting client card confirmation</div>
			<div style={{ fontSize: 13, color: '#7a5b00', marginBottom: 10 }}>
				This booking isn't dispatched yet — the client must confirm and add/authorize a card via the link.
				{booking.cardLinkExpiresAt ? ` Link expires ${new Date(Number(booking.cardLinkExpiresAt) || booking.cardLinkExpiresAt).toLocaleString()}.` : ''}
			</div>
			<button style={btn} disabled={busy} onClick={resend}>{busy ? 'Working…' : 'Resend link'}</button>
			<button style={btnGhost} disabled={busy} onClick={cancel}>Cancel booking</button>
			{msg ? <div style={{ marginTop: 10, fontSize: 14 }}>{msg}</div> : null}
		</div>
	);
}

export class ViewBooking extends Component {
	static propTypes = {
		data: PropTypes.shape({
			viewBookingDetails: PropTypes.object
		}),
	};

	static defaultProps = {
		data: {
			loading: true
		}
	};

	render() {
		const { formatMessage } = this.props.intl;
		const { data: { loading, viewBookingDetails, refetch }, from } = this.props;
		let title = formatMessage(messages.bookingDetails);

		if (!loading && !viewBookingDetails) {
			return <NotFound title={formatMessage(messages.pageNotFound)} />;
		} else {
			return (
				<Loader type={"page"} show={loading}>
					{!loading && viewBookingDetails &&
						<SocketContext.Consumer>
							{
								socket => (
									<div>
									{viewBookingDetails.awaitingClientCard ? <AwaitingCardBanner booking={viewBookingDetails} refetch={refetch} /> : null}
									<ViewBookingDetails data={viewBookingDetails}
										title={title}
										from={from}
										refetch={refetch}
										socket={socket}
									/></div>)
							}
						</SocketContext.Consumer>
					}
				</Loader>
			)
		}

	}
}


export default compose(
	injectIntl,
	withQuery(viewBookingDetails,
		{
			options: (props) => ({
				variables: {
					id: Number(props.id)
				},
				fetchPolicy: 'network-only',
				ssr: false
			})
		})
)(ViewBooking);
